import { render, staticRenderFns } from "./OnboardingCarousel.vue?vue&type=template&id=1507e328&scoped=true&"
import script from "./OnboardingCarousel.vue?vue&type=script&lang=js&"
export * from "./OnboardingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCarousel.vue?vue&type=style&index=0&id=1507e328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507e328",
  null
  
)

export default component.exports